import React from 'react';
import { Container, SectionTitle } from '../../components/ui';

export default function KebijakanPrivasi() {
  return (
    <main className="min-h-screen">
      {/* Hero */}
      <section className="py-16 md:py-20 bg-green-to-white-hero">
        <Container>
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-extrabold text-am-text-900 font-display">
              Kebijakan Privasi Aplikasi AmanKlik
            </h1>
            <p className="mt-4 text-am-text-700 text-base md:text-lg">
              Terakhir diperbarui: 11 Maret 2026
            </p>
          </div>
        </Container>
      </section>

      {/* Isi kebijakan privasi */}
      <section className="py-12 md:py-16 bg-white">
        <Container>
          <div className="max-w-4xl mx-auto prose prose-sm md:prose-base prose-headings:text-am-text-900 prose-p:text-am-text-700 prose-li:text-am-text-700">
            <SectionTitle
              title="Kebijakan Privasi"
              subtitle="Harap baca dengan saksama sebelum menggunakan Aplikasi AmanKlik."
              align="left"
              className="mb-6"
            />

            <h2 className="text-xl font-semibold mt-8">Pengantar</h2>
            <p>
              Selamat datang di platform AmanKlik yang dioperasikan oleh PT AMANAH MULIA NIAGA. Kami
              berkomitmen untuk melindungi privasi dan keamanan data pribadi Anda. Kebijakan Privasi ini
              menjelaskan bagaimana Kami mengumpulkan, menggunakan, mengungkapkan, menyimpan, dan memproses
              data pribadi Anda sesuai dengan peraturan perundang-undangan yang berlaku di Republik Indonesia,
              khususnya terkait perlindungan data pribadi.
            </p>
            <p>
              Dengan mengakses, mendaftar, atau menggunakan aplikasi AmanKlik (&quot;Aplikasi&quot;), Anda
              menyatakan telah membaca, memahami, dan menyetujui semua ketentuan dalam Kebijakan Privasi ini.
            </p>

            <h2 className="text-xl font-semibold mt-8">1. Data Pribadi yang Dikumpulkan</h2>
            <p>
              Kami mengumpulkan data pribadi Anda untuk berbagai keperluan yang dijelaskan dalam kebijakan
              ini. Data yang Kami kumpulkan meliputi:
            </p>

            <h3 className="text-lg font-semibold mt-4">a. Data Identitas dan Akun</h3>
            <ul className="list-disc pl-5">
              <li>Nama lengkap</li>
              <li>Nomor telepon</li>
              <li>Alamat email</li>
              <li>Nama pengguna (username) dan kata sandi (password)</li>
              <li>Foto profil (opsional)</li>
            </ul>

            <h3 className="text-lg font-semibold mt-4">b. Data Identitas Resmi (untuk Verifikasi Penjual)</h3>
            <ul className="list-disc pl-5">
              <li>Nomor Induk Kependudukan (NIK)</li>
              <li>Nomor Pokok Wajib Pajak (NPWP)</li>
              <li>Foto KTP atau dokumen identitas resmi lainnya</li>
              <li>Alamat lengkap sesuai KTP dan alamat pengiriman</li>
            </ul>

            <h3 className="text-lg font-semibold mt-4">c. Data Transaksi</h3>
            <ul className="list-disc pl-5">
              <li>Riwayat pembelian dan penjualan produk</li>
              <li>Detail pesanan (alamat pengiriman, catatan)</li>
              <li>Metode pembayaran yang dipilih</li>
              <li>
                Nomor rekening bank atau akun dompet digital untuk pencairan dana (khusus penjual)
              </li>
            </ul>

            <h3 className="text-lg font-semibold mt-4">d. Data Penggunaan dan Perangkat</h3>
            <ul className="list-disc pl-5">
              <li>Alamat IP (Internet Protocol)</li>
              <li>Jenis dan model perangkat yang digunakan</li>
              <li>Sistem operasi perangkat</li>
              <li>ID perangkat unik (misal: IMEI, nomor seri)</li>
              <li>Aktivitas Anda di dalam Aplikasi (halaman yang dikunjungi, fitur yang digunakan)</li>
            </ul>

            <h3 className="text-lg font-semibold mt-4">e. Data Lokasi</h3>
            <p>
              Perkiraan lokasi (berdasarkan alamat IP) untuk keperluan pengiriman dan penawaran yang relevan.
            </p>

            <h3 className="text-lg font-semibold mt-4">f. Data Komunikasi</h3>
            <p>
              Riwayat percakapan dengan layanan pelanggan (customer service) melalui chat, email, atau
              telepon.
            </p>

            <h2 className="text-xl font-semibold mt-8">2. Cara Pengumpulan Data</h2>
            <p>Kami mengumpulkan data pribadi Anda melalui beberapa cara berikut:</p>
            <ul className="list-disc pl-5">
              <li>
                <span className="font-semibold">Pendaftaran Langsung:</span> Saat Anda membuat akun di Aplikasi
                AmanKlik.
              </li>
              <li>
                <span className="font-semibold">Penggunaan Layanan:</span> Saat Anda melakukan transaksi
                jual-beli, berkomunikasi dengan penjual/pembeli, atau menggunakan fitur-fitur yang ada.
              </li>
              <li>
                <span className="font-semibold">Verifikasi:</span> Saat Anda, khususnya sebagai penjual,
                mengirimkan dokumen untuk proses verifikasi.
              </li>
              <li>
                <span className="font-semibold">Otomatis:</span> Secara otomatis melalui cookies dan teknologi
                serupa saat Anda berinteraksi dengan Aplikasi.
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-8">3. Penggunaan Data Pribadi</h2>
            <p>Data pribadi yang Kami kumpulkan akan digunakan untuk tujuan-tujuan berikut:</p>
            <ul className="list-disc pl-5">
              <li>
                <span className="font-semibold">Menyediakan dan Mengelola Layanan:</span> Untuk memproses
                pendaftaran akun, memverifikasi identitas, memfasilitasi transaksi jual beli, dan mengelola
                pesanan Anda.
              </li>
              <li>
                <span className="font-semibold">Memproses Pembayaran:</span> Untuk memproses transaksi
                pembayaran, termasuk bekerja sama dengan penyedia jasa pembayaran (payment gateway) dan bank.
              </li>
              <li>
                <span className="font-semibold">Komunikasi:</span> Untuk menghubungi Anda terkait transaksi,
                mengirimkan notifikasi penting (seperti konfirmasi pesanan, status pengiriman), dan merespons
                pertanyaan atau keluhan Anda.
              </li>
              <li>
                <span className="font-semibold">Peningkatan Layanan:</span> Untuk menganalisis penggunaan
                Aplikasi, memperbaiki fitur, mengembangkan produk baru, dan melakukan riset internal.
              </li>
              <li>
                <span className="font-semibold">Keamanan dan Pencegahan Penipuan:</span> Untuk mendeteksi,
                mencegah, dan menangani aktivitas penipuan, penyalahgunaan, atau pelanggaran terhadap Syarat
                dan Ketentuan yang berlaku.
              </li>
              <li>
                <span className="font-semibold">Pemasaran:</span> Untuk mengirimkan informasi tentang promo,
                diskon, atau fitur baru yang mungkin Anda minati. Anda dapat berhenti berlangganan
                (unsubscribe) dari komunikasi pemasaran kapan saja.
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-8">
              4. Pengungkapan Data kepada Pihak Ketiga
            </h2>
            <p>
              Kami dapat membagikan data pribadi Anda kepada pihak ketiga hanya dalam keadaan tertentu dan
              dengan itikad baik, antara lain:
            </p>
            <ul className="list-disc pl-5">
              <li>
                <span className="font-semibold">Mitra Layanan:</span> Kepada mitra yang membantu Kami dalam
                menjalankan bisnis, seperti perusahaan jasa pengiriman (logistik), penyedia layanan pembayaran
                (payment gateway), dan penyedia layanan pusat data (cloud computing). Mereka hanya diizinkan
                menggunakan data Anda untuk kepentingan layanan tersebut.
              </li>
              <li>
                <span className="font-semibold">Kewajiban Hukum:</span> Apabila diminta oleh aparat penegak
                hukum atau otoritas terkait berdasarkan ketentuan hukum yang berlaku, atau untuk menegakkan
                hak Kami, melindungi keamanan pengguna, serta mencegah kejahatan.
              </li>
              <li>
                <span className="font-semibold">Afiliasi Bisnis:</span> Kepada perusahaan afiliasi Kami untuk
                tujuan yang konsisten dengan kebijakan privasi ini.
              </li>
            </ul>
            <p className="mt-2">
              Kami tidak akan pernah menjual data pribadi Anda kepada pihak ketiga mana pun untuk tujuan
              pemasaran mereka sendiri tanpa persetujuan eksplisit dari Anda.
            </p>

            <h2 className="text-xl font-semibold mt-8">5. Penyimpanan dan Kehancuran Data</h2>
            <ul className="list-disc pl-5">
              <li>
                <span className="font-semibold">Lokasi Penyimpanan:</span> Data pribadi Anda disimpan secara
                aman di server yang berlokasi di Indonesia.
              </li>
              <li>
                <span className="font-semibold">Periode Penyimpanan:</span> Kami akan menyimpan data pribadi
                Anda selama akun Anda aktif atau selama diperlukan untuk memberikan layanan kepada Anda. Data
                juga dapat disimpan lebih lama jika diwajibkan oleh peraturan perundang-undangan yang berlaku,
                atau untuk keperluan penyelesaian sengketa dan penegakan perjanjian.
              </li>
              <li>
                <span className="font-semibold">Penghapusan Data:</span> Jika Anda menutup akun atau meminta
                penghapusan data, Kami akan menghapus atau menganonimkan data pribadi Anda, kecuali data yang
                masih wajib Kami simpan sesuai ketentuan hukum.
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-8">6. Keamanan Data</h2>
            <p>
              Kami berkomitmen untuk melindungi data pribadi Anda. Kami menerapkan berbagai langkah keamanan
              teknis dan prosedural untuk melindungi data Anda dari akses tidak sah, penggunaan yang salah,
              pengubahan, atau penghancuran, termasuk penggunaan enkripsi dan firewall. Namun, perlu Anda
              ingat bahwa tidak ada metode transmisi data melalui internet atau metode penyimpanan elektronik
              yang 100% aman.
            </p>

            <h2 className="text-xl font-semibold mt-8">7. Hak Anda atas Data Pribadi</h2>
            <p>Anda memiliki hak-hak tertentu terkait data pribadi Anda, antara lain:</p>
            <ul className="list-disc pl-5">
              <li>
                <span className="font-semibold">Hak Akses:</span> Meminta informasi mengenai data pribadi Anda
                yang Kami simpan.
              </li>
              <li>
                <span className="font-semibold">Hak Koreksi:</span> Meminta agar data pribadi Anda yang tidak
                akurat diperbaiki atau dilengkapi.
              </li>
              <li>
                <span className="font-semibold">Hak Penghapusan:</span> Meminta penghapusan data pribadi Anda,
                dengan tunduk pada ketentuan hukum yang berlaku.
              </li>
              <li>
                <span className="font-semibold">Hak Penarikan Persetujuan:</span> Menarik kembali persetujuan
                yang telah Anda berikan kapan saja.
              </li>
            </ul>
            <p className="mt-2">
              Untuk melaksanakan hak-hak Anda, silakan hubungi Kami melalui kontak yang tersedia di bawah.
            </p>

            <h2 className="text-xl font-semibold mt-8">8. Cookies</h2>
            <p>
              Aplikasi Kami menggunakan cookies dan teknologi serupa untuk mengumpulkan data penggunaan guna
              meningkatkan pengalaman pengguna dan menganalisis kinerja Aplikasi.
            </p>

            <h2 className="text-xl font-semibold mt-8">9. Privasi Anak-Anak</h2>
            <p>
              Layanan Kami tidak ditujukan bagi siapa pun yang berusia di bawah 17 (tujuh belas) tahun. Kami
              tidak dengan sengaja mengumpulkan data pribadi dari anak-anak. Jika Kami mengetahui telah
              mengumpulkan data pribadi dari anak tanpa persetujuan orang tua, Kami akan mengambil
              langkah-langkah untuk menghapus informasi tersebut.
            </p>

            <h2 className="text-xl font-semibold mt-8">10. Perubahan Kebijakan Privasi</h2>
            <p>
              Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu. Setiap perubahan akan
              diumumkan melalui Aplikasi atau saluran komunikasi lainnya, dan tanggal &quot;Terakhir
              diperbarui&quot; di bagian atas akan direvisi. Kami menyarankan Anda untuk meninjau halaman ini
              secara berkala.
            </p>

            <h2 className="text-xl font-semibold mt-8">11. Hubungi Kami</h2>
            <p>
              Jika Anda memiliki pertanyaan, komentar, atau keluhan mengenai Kebijakan Privasi ini atau
              praktik pengelolaan data pribadi Kami, silakan hubungi Kami melalui:
            </p>
            <ul className="list-disc pl-5">
              <li>
                <span className="font-semibold">Email:</span> amanmart@aman-store.id
              </li>
              <li>
                <span className="font-semibold">Layanan Pelanggan:</span> 08138009505
              </li>
            </ul>

            <p className="mt-4">
              Dengan menggunakan Aplikasi AmanKlik, Anda dianggap telah membaca, memahami, dan menyetujui
              seluruh ketentuan dalam Kebijakan Privasi ini.
            </p>
          </div>
        </Container>
      </section>
    </main>
  );
}

